import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

export const CookieBanner = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("gtl_cookie_consent");
    if (!saved) setVisible(true);
  }, []);

  const act = (val) => {
    localStorage.setItem("gtl_cookie_consent", val);
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className="fixed bottom-6 left-6 right-20 sm:right-24 md:left-6 md:right-auto md:max-w-md z-40 glass-strong rounded-2xl p-4 animate-fade-up" data-testid="cookie-banner">
      <div className="flex items-start gap-3">
        <p className="text-sm text-mid flex-1">{t.cookie.text}</p>
        <button onClick={() => setVisible(false)} className="text-soft hover:text-strong" aria-label="Close">
          <X className="w-4 h-4" />
        </button>
      </div>
      <div className="flex gap-2 mt-3">
        <button
          onClick={() => act("accepted")}
          data-testid="cookie-accept"
          className="flex-1 bg-cyan-400 hover:bg-cyan-300 text-slate-950 font-semibold text-sm px-4 py-2 rounded-lg"
        >
          {t.cookie.accept}
        </button>
        <button
          onClick={() => act("declined")}
          data-testid="cookie-decline"
          className="flex-1 bg-hover hover:bg-hover border border-soft text-strong text-sm px-4 py-2 rounded-lg"
        >
          {t.cookie.decline}
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
